import { Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { LinearProgress, Typography } from "@/components/ui-v2";

import { mapConsumptionToProgressColor } from "./utils";

interface WorkspaceDropdownUnitsProgressProps {
  percentageRemaining: number;
}

export const WorkspaceDropdownUnitsProgress = (
  props: WorkspaceDropdownUnitsProgressProps,
) => {
  const { percentageRemaining } = props;
  const theme = useTheme();

  const displayPercentage =
    percentageRemaining > 0 ? Math.round(100 - percentageRemaining) : 100;

  return (
    <Stack direction="column" gap={2} width="100%">
      <Typography variant="mini" color="secondary.2" fontWeight={200}>
        {displayPercentage.toFixed(0)}% of Creative Units Used
      </Typography>
      <LinearProgress
        variant="determinate"
        value={percentageRemaining}
        sx={{
          width: "100%",
          borderRadius: "5px",
          "& .MuiLinearProgress-bar1Determinate": {
            backgroundColor: mapConsumptionToProgressColor(
              percentageRemaining,
              theme,
            ),
          },
          "& .MuiLinearProgress-dashed": {
            display: "none",
          },
          backgroundColor: "secondary.4",
        }}
      />
    </Stack>
  );
};
